import { parseLocalDate } from '../../domain/utils/local-date';
import {Component, Input, OnInit} from '@angular/core';
import {EnrollmentRentalPropertyModel} from "../../domain/models/enrollment-rental-property.model";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {LocationService} from "../../domain/services/location/location.service";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {EnrollmentComponent} from "../enrollment-request/EnrollmentComponent";
import {EnrollmentModel} from "../../domain/models/enrollment.model";
import {FrequencyLabelMap} from "../../domain/enums/occupation-freq.enum";
import {CommonModule} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";
import {JurisdictionService} from "../../domain/services/jurisdiction/jurisdiction.service";
import {Jurisdiction} from "../../domain/models/distribution.model";
import {AppraiserOfficeService} from "../../domain/services/appraiser-office/appraiser-office.service";
import {AppraiserOfficeModel} from "../../domain/models/appraiser-office.model";

@Component({
  selector: 'app-rental-property-info',
  standalone: true,
  imports: [
    FormsModule,
    MatFormField,
    MatInputModule,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    MatDatepickerModule,
    CommonModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './rental-property-info.component.html',
  styleUrl: './rental-property-info.component.css'
})
export class RentalPropertyInfoComponent implements OnInit, EnrollmentComponent {
  @Input() property!: EnrollmentRentalPropertyModel;
  cities: any[] = [];
  states: any[] = [];
  countries: any[] = [];
  appraiserOffices: AppraiserOfficeModel[] = [];
  propertyForm!: FormGroup;

  constructor(private fb: FormBuilder,
              private readonly locationService: LocationService,
              private readonly appraiserOfficeService: AppraiserOfficeService,
              private readonly jurisdictionService: JurisdictionService) {
  }

  jurisdictions: Jurisdiction[] = [];

  ngOnInit(): void {
    this.appraiserOfficeService.getAll().subscribe((offices) => {
      this.appraiserOffices = offices.filter((o) => o.active);
    });
    this.jurisdictionService.listActive().subscribe(js => this.jurisdictions = js);
    this.buildForm(this.property);
    this.pullCatalogs();
  }

  buildForm(info: EnrollmentRentalPropertyModel | undefined): void {
    const stateId = info?.state ?? info?.stateId;
    this.propertyForm = this.fb.group({
      officeId: [info?.appraiserOfficeId ?? '', Validators.required],
      jurisdiction: [info?.jurisdiction ?? '', Validators.required],
      street: [info?.rentalPropertyStreetAddress ?? '', Validators.required],
      aptUnitSuite: [info?.aptUnitSute ?? ''],
      city: [info?.city ?? '', Validators.required],
      state: [stateId ?? '', Validators.required],
      zip: [info?.zipCode ?? '', [Validators.required, Validators.pattern(/^\d{5}(?:-\d{4})?$/)]],
      started: [parseLocalDate(info?.startedRenting as any) ?? ''],
      frequency: [info?.frequency ?? '', Validators.required]
    });
  }

  private pullCatalogs() {
    this.locationService.getCountryList().subscribe(countryList => {
      this.countries = countryList;
    })
    this.locationService.getStateList().subscribe(states => {
      this.states = states;
    });
  }

  public getFormData(): EnrollmentRentalPropertyModel {
    const formValues = this.propertyForm.value;

    return {
      rentalPropertyStreetAddress: formValues.street,
      aptUnitSute: formValues.aptUnitSuite,
      city: formValues.city,
      zipCode: formValues.zip,
      startedRenting: formValues.started ? new Date(formValues.started) : undefined,
      frequency: formValues.frequency,
      state: formValues.state,
      appraiserOfficeId: formValues.officeId,
      jurisdiction: formValues.jurisdiction,
    } as EnrollmentRentalPropertyModel;

  }

  getUpdatedEnrollment(): EnrollmentModel {
    return {
      enrollmentRentalProperty: this.getFormData()
    };
  }

  isFormValid(): boolean {
    return this.propertyForm.valid;
  }

  raiseFormValidations(): void {
    this.propertyForm.markAllAsTouched()
  }

    protected readonly FrequencyLabelMap = FrequencyLabelMap;
}
